(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('UsuariologDeleteController',UsuariologDeleteController);

    UsuariologDeleteController.$inject = ['$uibModalInstance', 'entity', 'Usuariolog'];

    function UsuariologDeleteController($uibModalInstance, entity, Usuariolog) {
        var vm = this;

        vm.usuariolog = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Usuariolog.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
